import { getRoutePermission } from '@/constants/authorization/route-permissions'

export function getShortcutPermission(shortcut: { permission?: string | string[]; route?: string }) {
  if (shortcut.permission) return shortcut.permission
  return getRoutePermission(shortcut.route ?? null)
}

export default getShortcutPermission
